// ── ÍCONES do HUD e do kill feed (uma definição só) ───────────────────────────
// `WEAPON_ICON` morava dentro de Hud.jsx; o feed precisa dos MESMOS símbolos, e duas listas que precisam
// concordar acabam discordando.
export const WEAPON_ICON=["🚀","✳️","💥","🌟"];   // mesma ordem de WEAPONS: o id indexa direto
/** Como alguém morreu — ou, quando o abate foi por absorção, o que AMOLECEU antes (a assistência). */
export const HOW_ICON={eat:"🍴",missile:"🚀",burst:"✳️",cluster:"💥",nova:"🌟",
  star:"⭐",asteroid:"☄️",zone:"☣️",hole:"🕳️",supernova:"💫"};
export const SYS_ICON={start:"🚦",lead:"👑",crunch:"⏳",zone:"☣️",few:"💀",streak:"🔥"};
